import {svgIconWrapper} from '../svg-icon-wrapper';

import HierarchyRegular from './hierarchy-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HierarchyRegular {...validProps} />;
}

SvgComponent.iconName = 'hierarchy-regular';

export const HierarchyRegularIcon = svgIconWrapper(SvgComponent);
